import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedVideos from "./components/FeaturedVideos";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";

export default function Home() {
  useEffect(() => {
    document.title = "妖精视频 妖精视频-香蕉视频蜜桃视频高清在线观看 | 西瓜视频樱花视频免费全集不缓冲";
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "妖精视频",
        url: "https://www.yaojingshipin.com",
        description: "妖精视频水果植物系列，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，高清免费在线观看。",
        sameAs: ["https://weibo.com/yaojingshipin", "https://space.bilibili.com/yaojingshipin"],
      },
      {
        "@type": "WebSite",
        name: "妖精视频",
        url: "https://www.yaojingshipin.com",
        description: "妖精视频水果植物系列 - 高清免费在线观看",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: "https://www.yaojingshipin.com/category/all?q={search_term_string}",
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "WebPage",
        name: "妖精视频 - 高清免费在线观看 | 电视剧全集不缓冲",
        description: "妖精视频水果植物系列，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，高清免费在线观看，电视剧全集不缓冲，最新电影大全一网打尽。",
        url: "https://www.yaojingshipin.com",
        isPartOf: { "@id": "https://www.yaojingshipin.com/#website" },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <header>
        <Navbar />
      </header>

      <main>
        <h1 className="sr-only">
          妖精视频 - 水果植物系列，香蕉视频蜜桃视频西瓜视频樱花视频高清在线观看
        </h1>
        <article>
          <HeroSection />
        </article>
        <article>
          <CategoryGrid />
        </article>
        <article>
          <FeaturedVideos />
        </article>
        <article>
          <LatestArticles />
        </article>
        <article>
          <FAQSection />
        </article>
      </main>

      <Footer />
    </div>
  );
}